import { render } from "./index.vue?vue&type=template&id=13dadb8a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=13dadb8a&lang=scss"

import exportComponent from "/root/workspace/youyi_1_tob-teacher-fe_Ff2X/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__